export class VideoPlayer {
	constructor() {
		customElements.whenDefined('media-controller').then(() => {
			this.setupFullscreen();
		});
	}

	setupFullscreen() {
		document.querySelectorAll('.video__wrapper[id^="video-wrapper-"]').forEach(wrapper => {
			const controller = wrapper.querySelector('media-controller');
			if (controller) {
				controller.fullscreenElement = wrapper;
			}
		});
	}
}
